var map = {
	"./animalcapptured.png": "dca0",
	"./animaldeath.png": "df80",
	"./animalinjured.png": "2de8",
	"./animalreleased.png": "d183",
	"./authentication - Copy/login.jpg": "cbf8",
	"./authentication - Copy/loginVerify.jpg": "2a76",
	"./authentication - Copy/verificationComplete.jpg": "86cb",
	"./authentication - Copy/welcome.jpg": "b31e",
	"./authentication/homelogo.png": "d5b9",
	"./authentication/login.jpg": "f5d7",
	"./authentication/loginVerify.jpg": "4b13",
	"./authentication/loginimage.png": "9e44",
	"./authentication/verificationComplete.jpg": "0405",
	"./authentication/welcome.jpg": "12cc",
	"./avatar.png": "4d41",
	"./bluevert.png": "ce04",
	"./dash1.png": "7de9",
	"./dash2.png": "f237",
	"./dash3.png": "6355",
	"./dash4.png": "9783",
	"./dash5.png": "37ee",
	"./dash6.png": "1550",
	"./dash7.png": "c18a",
	"./dash8.png": "ed31",
	"./dummylogo.jpg": "9173",
	"./elephantreported.png": "3dee",
	"./greenvert.png": "a824",
	"./greyvert.png": "feed",
	"./high.png": "41cc",
	"./highthreat.png": "309c",
	"./humandeath.png": "8136",
	"./humaninjury.png": "a81a",
	"./idhelp.png": "e94c",
	"./listedsnakes.png": "3b06",
	"./listhosp.png": "f054",
	"./low.png": "afdc",
	"./lowthreat.png": "db82",
	"./mapicon.png": "843d",
	"./medium.png": "9614",
	"./mediumthreat.png": "e583",
	"./newrescuersnew.png": "8426",
	"./noimage.jpg": "750c",
	"./noimagesarpa.jpg": "0b92",
	"./orangevert.png": "ba9d",
	"./pinkvert.png": "60b5",
	"./publicusericon.png": "2972",
	"./publicusericonnew.png": "194b",
	"./publicusers.png": "b1bc",
	"./purplevert.png": "a2c2",
	"./redvertical.png": "b049",
	"./releaseloc.png": "2f14",
	"./reportloc.png": "2842",
	"./rescuericon.png": "8794",
	"./resolveloc.png": "ce90",
	"./sidebar/dashboard.png": "b5a7",
	"./snakedeath.png": "d73e",
	"./snakeicon.png": "2f5e",
	"./snakereleased.png": "a72b",
	"./snakereported.png": "3f3a",
	"./snakeresc.png": "06b6",
	"./snakerescued.png": "3e2c",
	"./snakerescuers.png": "3785",
	"./snakerescuersdash.png": "710d",
	"./tiger.jpg": "d935",
	"./tigerreported.png": "181b",
	"./totalusers.png": "cad3",
	"./vert1.png": "4c42",
	"./vert2.png": "cfe6",
	"./vert3.png": "e2e8",
	"./vert4.png": "337d",
	"./vert5.png": "2851",
	"./vert6.png": "c938",
	"./vert7.png": "a324",
	"./vert8.png": "2d16",
	"./yellowvert.png": "1edd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";